export const CurrencyFilter = angular
    .module('checkout.filters.vCurrency', [])
    .filter('vCurrency', ($filter, $locale) => {
        return (amount, currencySymbol) => {
            var currency = $filter('currency');

            if (amount === 0) {
                return 'Free';
            }

            if ($locale.id === 'en-us' && amount < 0) {
                return currency(amount, currencySymbol).replace('(', '-').replace(')', '');
            }

            return currency(amount, currencySymbol);
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/filters/vCurrency.js